<template>
    <div>
        <filter-container
            :filterData="filterData"
            :filterDataSelected="filterDataSelected"
            :isPreloader="isPreloader"
            @onChangeFilter="onChangeFilter"
        />
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                {{currentTitle}}
            </div>
            <table-treeview
                :tableTabs="tableTabs"
                :isPreloader="isPreloader"
                :tableData="tableData"
                :isSort="true"
                :columnsSort="columnsSort"
                :columnsStyles="columnsStyles"
                :sortState="sortState"
                :sortColumn="sortColumn"
                :render="render"
                @onClickTableItem="onClickTableItem"
                @onClickTreeTab="onClickTreeTab"
                @onToggleSort="onToggleSort"
            />
        </div>
    </div>
</template>

<script>
import FilterContainer from '../../components/Filter/FilterContainer';
import TableTreeview from '../../components/Tables/TableTreeview';
import mixinAnalytics from '../../mixins/mixinAnalytics';
import mixinTableTreeview from '../../mixins/mixinTableTreeview';
import mixinTable from '../../mixins/mixinTable';
import serviceApi from '../../services/serviceApi';
export default {
    name: 'ViewAnalyticsSupplyers',
    components: {
        FilterContainer,
        TableTreeview
    },
    mixins: [
        mixinAnalytics,
        mixinTableTreeview,
        mixinTable
    ],
    /**
     * входные данные компонента
     * @property {string} currentRoute - текущий маршрут
     * @property {string} currentTitle - текущий заголовок
     * @property {Object} tableTabs - текущие табы
     */
    props: {
        currentRoute: {
            type: String,
            default: ''
        },
        currentTitle: {
            type: String,
            default: ''
        },
        tableTabs: {
            type: Object,
            default: () => ({})
        },
        tableFirstColumn: {
            type: String,
            default: ''
        }
    },
    /**
     * Входные данные компонента
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {object} tableData - данные таблицы
     * @property {object} tableDataDefault - данные таблицы без сортировки
     * @property {string} mode - текущий таб
     */
    data: () => ({
        isPreloader: false,
        tableData: {},
        tableDataDefault: {},
        mode: 'default',
        render: 0
    }),
    computed: {
        columnsStyles() {
            let columnsStyles = {};
            const {columns = {}} = this.tableData;
            Object.keys(columns).forEach((column) => {
                switch(column) {
                    case 'rowLabel':
                        columnsStyles[column] = {};
                        break;
                    default:
                        columnsStyles[column] = {'text-align': 'right',};
                        break;
                }
            });
            return columnsStyles;
        },
        /**
         * тело запроса
         * @returns {object}
         */
        reqBodyGetData() {
            let reqBody = {
                filter_params: this.filterDataSelected
            }
            return reqBody;
        },
        /**
         * колонки по которым можно сортировать
         * @returns {object}
         */
        columnsSort() {
            let columnsSort = {};
            let {columns = {}} = this.tableData;
            Object.keys(columns).forEach((column) => {
                switch (column) {
                    case 'rowLabel':
                        columnsSort[column] = {typeColumn: 'String'};
                    break;
                    case 'avg_agency_discount':
                    case 'avg_client_discount':
                    case 'marginality':
                        columnsSort[column] = {typeColumn: 'Percent'};
                    break;
                    default:
                        columnsSort[column] = {typeColumn: 'Number'};
                    break;
                }
            });
            return columnsSort;
        }
    },
    watch: {
      tableFirstColumn(){
        let tableData = this.tableData;
        if(Object.keys(tableData).includes('columns')){
          tableData.columns.rowLabel = this.tableFirstColumn;
        }
        this.tableData = Object.assign({}, tableData)
      }
    },
    mounted() {
        this.getData();
    },
    methods: {
        /**
         * сделать запрос на получения данных
         * @async
         */
        async getData() {
            this.isPreloader = true;
            this.tableData = {};
            let reqBody = {
                tree: {
                    mode: this.mode
                },
                ...this.reqBodyGetData
            };
            try {
                this.sortState = 0;
                this.sortColumn = '';
                let {data = {}} = await serviceApi.post(this.currentRoute, reqBody);
                let {filter = {}, analytics = {}} = data;
                let {options = {}, column_labels: columnsLabels = {}, row_labels: rowLabels = {}, table_data: tableData = {}} = analytics;
                let {next = ''} = options;

                this.setFilterData(filter);
                if(!this.treviewKeys.includes(next))
                    this.treviewKeys.push(next);
                this.tableData = this.collectDataTable(options, columnsLabels, rowLabels, tableData);
                this.tableDataDefault = Object.assign({}, this.tableData);
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isPreloader = false;
        },
        /**
         * сделать запрос на получения подстрок
         * @async
         * @param {object} condition - элементы иерархии дерева
         * @param {string} element - ключ элемента
         * @returns {promise}
         */
        async getDataSubrows(condition, element) {
            let reqBody = {
                tree: {
                    condition: condition,
                    element: element,
                    mode: this.mode
                },
                ...this.reqBodyGetData
            };
            try {
                let {data = {}} = await serviceApi.post(this.currentRoute, reqBody);
                let {analytics = {}} = data;
                let {options = {}, column_labels: columnsLabels = {}, row_labels: rowLabels = {}, table_data: tableData = {}} = analytics;
                let {next = ''} = options;

                if(!this.treviewKeys.includes(next))
                    this.treviewKeys.push(next);
                let subdata = this.collectDataTable(options, columnsLabels, rowLabels, tableData);
                let sortSubdata = {...subdata};
                if (this.sortState !== 0) {
                    sortSubdata = {
                        ...sortSubdata,
                        rows: this.rowsSort(subdata.rows, this.sortColumn, this.sortStates[this.sortState].type)
                    };
                }
                this.tableData = this.treeviewTableAddSubdata(Object.assign({}, this.tableData), sortSubdata, condition, Object.keys(condition).length, 0);
                this.tableDataDefault = this.treeviewTableAddSubdata(Object.assign({}, this.tableDataDefault), subdata, condition, Object.keys(condition).length, 0);
                return true;
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
                return false;
            }
        },
        /**
         * собрать данные для таблицы
         * @param {object} options - опции
         * @param {object} columnsLabels - заголовки колонок
         * @param {object} rowLabels - заголовки строк
         * @param {object} tableData - данные таблиц
         * @returns {object}
         */
        collectDataTable(options, columnsLabels, rowLabels, tableData) {
            tableData = Array.isArray(tableData) ? {} : tableData;
            rowLabels = Array.isArray(rowLabels) ? {} : rowLabels;
            
            let columns = {
                rowLabel: this.tableFirstColumn,
                ...columnsLabels
            }
            
            let rows = {};
            for (let [tableDataKey, tableDataValue] of Object.entries(tableData)) {
                let collectRow = {
                    rowLabel: rowLabels[tableDataKey],
                    ...tableDataValue
                };
                rows[tableDataKey] = collectRow;
            }

            let tableDataCollected = {
                options: options,
                columns: columns,
                rowLabels: rowLabels,
                rows: new Map(Object.entries(rows)),
                rowKeyPreloader: '',
                subdata: {},
                rowsActive: []
            };
            return tableDataCollected;
        },
        /**
         * событие изменения фильтра
         * @param {object} newFilterData - новые данные фильтра
         */
        onChangeFilter(newFilterData) {
          this.setFilterSelected(newFilterData);
            this.filterDataSelected = newFilterData;
            this.getData();
        },
        /**
         * событие клика по строке
         * @param {object} condition - элементы иерархии дерева
         * @param {string} element - ключ элемента
         * @param {string} rowKey - ключ строки
         */
        onClickTableItem(condition, element, rowKey) {
            let data = this.treeviewTableGetSubdata(Object.assign({}, this.tableData), condition, Object.keys(condition).length, 0);
            let {subdata = {}, rowsActive = []} = data;
            
            if (!Object.keys(subdata).includes(rowKey)) {
                this.tableData = this.treeviewTableSetRowPreloader(Object.assign({}, this.tableData), rowKey, condition, Object.keys(condition).length, 0);
                this.getDataSubrows(condition, element, rowKey).then((result) => {
                    if(result === true) {
                        this.tableData = this.treeviewTableAddRowActive(Object.assign({}, this.tableData), rowKey, condition, Object.keys(condition).length, 0);
                        this.tableDataDefault = this.treeviewTableAddRowActive(Object.assign({}, this.tableDataDefault), rowKey, condition, Object.keys(condition).length, 0);
                    }
                    this.tableData = this.treeviewTableSetRowPreloader(Object.assign({}, this.tableData), '', condition, Object.keys(condition).length, 0);
                })
            }
            else {
                if(rowsActive.includes(rowKey)) {
                    this.tableData = this.treeviewTableRemoveRowActive(Object.assign({}, this.tableData), rowKey, condition, Object.keys(condition).length, 0);
                    this.tableDataDefault = this.treeviewTableAddRowActive(Object.assign({}, this.tableDataDefault), rowKey, condition, Object.keys(condition).length, 0);
                }
                else {
                    this.tableData = this.treeviewTableAddRowActive(Object.assign({}, this.tableData), rowKey, condition, Object.keys(condition).length, 0);
                    this.tableDataDefault = this.treeviewTableAddRowActive(Object.assign({}, this.tableDataDefault), rowKey, condition, Object.keys(condition).length, 0);
                }
            }
            this.updateRender();
        },
        /**
         * событие клика по табу
         * @property {string} tabKey - текущий таб
         */
        onClickTreeTab(tabKey) {
            this.mode = tabKey;
            this.treviewKeys = [];
            this.getData();
        },
        /**
         * переключение режима сортировки
         * @param {string} currentSortState - текущее состояние режима сортировки
         * @param {string} column - колонка по которой сортируем
         */
        onToggleSort(currentSortState, column) {
            if(currentSortState === Object.keys(this.sortStates).length - 1)
                this.sortState = 0;
            else
                this.sortState = currentSortState + 1;
            this.sortColumn = column;
            let typeSort = this.sortStates[this.sortState].type;
            if (typeSort === 'none') {
                this.tableData = {...this.tableDataDefault};
            }
            else {
                let newData = this.rowsSortRecursion(this.tableData, column, typeSort);
                this.tableData = {...newData};
            }
            this.updateRender();
        },
        /**
         * отсортировать строки рекурсивно
         * @param {object} data - данные
         * @param {string} column - колонка по которой сортируем
         * @param {string} typeSort - тип сортировки
         * @returns {object}
         */
        rowsSortRecursion(data, column, typeSort) {
            let newData = {
                ...data,
                rows: this.rowsSort(data.rows, column, typeSort)
            };
            if (typeof data.subdata !== 'undefined') {
                Object.keys(data.subdata).forEach((key) => {
                    newData.subdata[key] = this.rowsSortRecursion(data.subdata[key], column, typeSort);
                });
            }
            return newData;
        },
        /**
         * отсортировать строки
         * @param {Map} rows - строки
         * @param {string} column - колонка по которой сортируем
         * @param {string} typeSort - тип сортировки
         * @returns {Map}
         */
        rowsSort(rows, column, typeSort) {
            let filteredRows = new Map();
            if (this.columnsSort[column].typeColumn === 'Number') {
                filteredRows = this.sortNumberMap(typeSort, rows, column);
            }
            if (this.columnsSort[column].typeColumn === 'String') {
                filteredRows = this.sortStringMap(typeSort, rows, column);
            }
            if (this.columnsSort[column].typeColumn === 'Percent') {
                filteredRows = this.sortPercentMap(typeSort, rows, column);
            }
            return filteredRows;
        },
        /**
         * обновить рендер таблицы
         */
        updateRender() {
            const maxRender = 100;
            this.render = this.render === maxRender ? 0 : this.render + 1;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>